// extracted by mini-css-extract-plugin
export default {"newLineDestination":"newLineDestination__1eT-F"};